import { redirect } from 'react-router-dom';

import store from 'config/redux/index';
import { error } from 'config/redux/slice';
import { AppConstants, RouteConstants } from '../constants';
import { ServiceModel } from 'models';
import { AppUtils } from 'utils';
import { PublicService } from 'services';
import { navigate } from 'utils/navigation';

const { SUPPORTED_ERRORS_CODES } = AppConstants;
const { ROUTE_LOGIN } = RouteConstants;

// Dedupe concurrent renewals: parallel 401s await the SAME renew() instead of N renews.
let inFlightRenewal: Promise<boolean> | null = null;

// Timestamp of the last successful renewal. A 401 within RENEWAL_COOLDOWN_MS of it means
// the freshly-renewed token was ALSO rejected -> stop renewing, log out. Breaks the loop.
let lastRenewalAt = 0;
const RENEWAL_COOLDOWN_MS = 3000;

function renewOnce(): Promise<boolean> {
  if (inFlightRenewal) return inFlightRenewal;
  inFlightRenewal = PublicService.renew()
    .then((ok) => {
      if (ok) lastRenewalAt = Date.now();
      return ok;
    })
    .finally(() => { inFlightRenewal = null; });
  return inFlightRenewal;
}

function forceLogout() {
  if (window.location.pathname !== ROUTE_LOGIN) {
    AppUtils.logout();
    redirect(ROUTE_LOGIN);
  }
}

export async function handleErrorWithTokenRenewal(error: any, method: any, methodParams: any[], serviceId: string) {
  const err = JSON.parse(JSON.stringify(error));
  console.log('[API ERROR]', error);

  if (err?.status !== 401) {
    handleServiceError(serviceId, error);
    return;
  }

  // Renewed very recently and STILL got 401 -> new token is rejected too. Do not loop.
  if (Date.now() - lastRenewalAt < RENEWAL_COOLDOWN_MS) {
    forceLogout();
    return;
  }

  try {
    const renewed = await renewOnce();
    if (renewed) {
      setTimeout(() => method(...methodParams), 250);
      return;
    }
    forceLogout();
  } catch (renewError) {
    forceLogout();
  }
}

export function handleServiceError(serviceId: string, err: any) {
  let { status, code, response } = err;
  if (status === 400 && response) {
    store.dispatch(error(new ServiceModel(serviceId, response.data)));
    return;
  } else if (SUPPORTED_ERRORS_CODES.includes(status)) {
    errorRedirect(status);
  } else if (code === 'ERR_NETWORK') {
    errorRedirect(503);
  } else if (code === 'ERR_BAD_RESPONSE') {
    errorRedirect(500);
  }
  store.dispatch(error(new ServiceModel(serviceId, err)));
}

function errorRedirect(status: number) {
  navigate('/fehler/' + status);
}